module.exports = __webpack_public_path__ + "media/newstyle/images/stars_sprint_red-92921276b7395e881c115c805429aa5e.svg";